
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { ofArray, fold, map, toArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { ImageDecorator } from "../Bindings/Feliz.ReactViewer.js";
import { concat } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import react_viewer from "react-viewer";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";

export function ImageViewer(props) {
    const props_1 = toList(delay(() => append(singleton(["images", toArray(map((image) => (new ImageDecorator(image.Src)), props.Images))]), delay(() => append(singleton(["visible", props.IsOpen]), delay(() => append(singleton(["onClose", props.OnClose]), delay(() => append(singleton(["onMaskClick", props.OnClose]), delay(() => {
        let matchValue;
        return append((matchValue = props.ActiveIndex, (matchValue == null) ? (empty()) : singleton(["activeIndex", matchValue])), delay(() => singleton(["className", fold((a, b) => concat(a, " ", ...b), "", ofArray(["z-[10000]", "relative"]))])));
    }))))))))));
    return reactApi.createElement(react_viewer, createObj(props_1));
}

